import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { isHaddockEnvironment } from "utils/documentUtils";

function UpgradeModal({
	show,
	onClose,
	feature,
	message,
	requiredPlan = "Pro",
}) {
	const { t } = useTranslation();
	const isHaddock = isHaddockEnvironment();

	const features = [
		t('upgradeModal.feature1'),
		t('upgradeModal.feature2'),
		t('upgradeModal.feature3'),
		t('upgradeModal.feature4'),
		t('upgradeModal.feature5'),
	];

	return (
		<Modal
			show={show}
			onHide={onClose}
			centered
			dialogClassName="upgrade-modal-dialog"
		>
			<Modal.Header closeButton>
				<Modal.Title>
					{t('upgradeModal.title')}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{isHaddock ? (
					<>
						<p className="upgrade-modal-haddock-title">
							{t('upgradeModal.haddockTitle')}
						</p>
						<p className="upgrade-modal-haddock-text">
							{t('upgradeModal.haddockTextPrefix')}{" "}
							<span className="upgrade-modal-haddock-bold">{t('upgradeModal.haddockTextBold')}</span>.
						</p>
					</>
				) : (
					<>
						<p className="upgrade-modal-main-text">
							{t('upgradeModal.mainTextPrefix')}{" "}
							<span className="upgrade-modal-bold">{t('upgradeModal.mainTextBold', { plan: requiredPlan })}</span>.
						</p>

						<div className="upgrade-modal-features-container">
							<p className="upgrade-modal-features-title">
								{t('upgradeModal.featuresTitle')}
							</p>
							<ul className="list-unstyled upgrade-modal-features-list">
								{features.map((feat, index) => (
									<li key={index}>
										<span className="upgrade-modal-check">✓</span>
										<span className="upgrade-modal-feature-text">{feat}</span>
									</li>
								))}
							</ul>
						</div>

						<p className="upgrade-modal-footer-text">
							{t('upgradeModal.footerTextPrefix')}{" "}
							<span className="upgrade-modal-footer-bold">{t('upgradeModal.footerTextBold')}</span>.
						</p>
					</>
				)}
			</Modal.Body>
			<Modal.Footer>
				<button className="btn btn-secondary" onClick={onClose}>
					{t('common.close')}
				</button>
			</Modal.Footer>
		</Modal>
	);
}

const mapStateToProps = (state) => ({
	user: state.authReducer.user,
});

export default connect(mapStateToProps)(UpgradeModal);
